export const SPECULATIVE_ITERATION_CONTRACT_REVISION = 1;
export class SpeculativeIterationError extends Error {
    constructor(message) {
        super(message);
        this.name = "SpeculativeIterationError";
    }
}
export function planSpeculativeProposal(input) {
    assertPositiveSafeInteger(input.remainingOutputTokens, "remainingOutputTokens");
    assertNonNegativeSafeInteger(input.maxAdditionalTokens, "maxAdditionalTokens");
    if (input.maxTargetTokenWidth !== undefined) {
        assertPositiveSafeInteger(input.maxTargetTokenWidth, "maxTargetTokenWidth");
    }
    const maxProposalTokens = Math.min(input.remainingOutputTokens, input.maxTargetTokenWidth === undefined
        ? input.remainingOutputTokens
        : Math.max(0, input.maxTargetTokenWidth - 1));
    const guaranteedTargetTokens = input.proposalPrefix === "guaranteed_target"
        && maxProposalTokens >= 1
        ? 1
        : 0;
    const proposedAdditionalTokens = input.proposalPrefix === "guaranteed_target"
        && guaranteedTargetTokens === 0
        ? 0
        : Math.min(input.maxAdditionalTokens, maxProposalTokens - guaranteedTargetTokens);
    const proposedDraftTokens = guaranteedTargetTokens + proposedAdditionalTokens;
    return {
        guaranteedTargetTokens,
        proposedAdditionalTokens,
        proposedDraftTokens,
        targetTokenWidth: proposedDraftTokens + 1,
    };
}
export function decideSpeculativeIteration(proposal, acceptedAdditionalTokens, remainingOutputTokens) {
    assertNonNegativeSafeInteger(acceptedAdditionalTokens, "acceptedAdditionalTokens");
    assertPositiveSafeInteger(remainingOutputTokens, "remainingOutputTokens");
    if (acceptedAdditionalTokens > proposal.proposedAdditionalTokens) {
        throw new SpeculativeIterationError(`accepted ${acceptedAdditionalTokens} additional tokens but only ${proposal.proposedAdditionalTokens} were proposed`);
    }
    if (proposal.proposedDraftTokens > remainingOutputTokens) {
        throw new SpeculativeIterationError("proposal exceeds the remaining output budget");
    }
    const acceptedDraftTokens = proposal.guaranteedTargetTokens + acceptedAdditionalTokens;
    const targetAuthoritativeTokens = proposal.proposedDraftTokens > 0
        && acceptedDraftTokens === proposal.proposedDraftTokens
        && proposal.proposedDraftTokens === remainingOutputTokens
        ? 0
        : 1;
    const outcome = proposal.proposedDraftTokens === 0
        ? "target_only"
        : acceptedDraftTokens < proposal.proposedDraftTokens
            ? "correction"
            : targetAuthoritativeTokens === 0
                ? "accepted_tail"
                : "bonus";
    return {
        ...proposal,
        acceptedAdditionalTokens,
        acceptedDraftTokens,
        rejectedDraftTokens: proposal.proposedDraftTokens - acceptedDraftTokens,
        targetAuthoritativeTokens,
        committedTokens: acceptedDraftTokens + targetAuthoritativeTokens,
        outcome,
    };
}
function assertNonNegativeSafeInteger(value, label) {
    if (!Number.isSafeInteger(value) || value < 0) {
        throw new SpeculativeIterationError(`${label} must be a non-negative safe integer; got ${value}`);
    }
}
function assertPositiveSafeInteger(value, label) {
    if (!Number.isSafeInteger(value) || value <= 0) {
        throw new SpeculativeIterationError(`${label} must be a positive safe integer; got ${value}`);
    }
}
//# sourceMappingURL=speculative-iteration.js.map